export default "//cloud.imgsmail.ru/cloud.mail.ru/146512/img/build/errors/error-429.png";